var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgTestTube = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4744 3.24242C12.8611 2.85572 13.4881 2.85572 13.8748 3.24242L20.7571 10.1248C21.1439 10.5115 21.1439 11.1385 20.7571 11.5252C20.3704 11.9119 19.7435 11.9119 19.3567 11.5252L12.4744 4.64282C12.0877 4.25611 12.0877 3.62913 12.4744 3.24242ZM17.03 3.65658C17.9449 2.74169 19.4282 2.74169 20.3431 3.65658C21.258 4.57147 21.258 6.0548 20.3431 6.96969L20 7.31277L16.6869 3.99966L17.03 3.65658ZM12.5303 6.49978L17.5 11.4694L15.7457 13.2237L6.63459 12.3955L12.5303 6.49978ZM5.25391 13.7761L14.365 14.6044L8.74721 20.2222C7.37487 21.5945 5.14988 21.5945 3.77754 20.2222C2.40521 18.8498 2.40521 16.6248 3.77755 15.2525L5.25391 13.7761Z",
    fill: "#FF8C42"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTestTube);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/test_tube.eb20ef55dc618fb782d65f7552648daf.svg";